import { tva } from "@gluestack-ui/utils";

export const chipStyle = tva({
	base: "flex flex-row gap-2 items-center justify-center web:w-fit",
	variants: {
		action: {
			default: "bg-neutral-50",
			selected: "bg-secondary-400",
		},
		size: {
			xs: "rounded-lg h-9 px-4",
			sm: "rounded-xl h-12 px-6",
		},
		disabled: {
			true: "",
		},
	},
	compoundVariants: [
		{
			action: "default",
			disabled: false,
			class: "hover:bg-neutral-100 active:bg-neutral-200",
		},
		{
			action: "selected",
			disabled: false,
			class: "hover:bg-secondary-500 active:bg-secondary-600",
		},
	],
});

export const labelStyle = tva({
	base: "font-medium text-sm web:select-none",
	parentVariants: {
		action: {
			default: "text-neutral-950",
			selected: "text-neutral-0",
		},
	},
});

export const iconStyle = tva({
	parentVariants: {
		action: {
			default: "text-neutral-950",
			selected: "text-neutral-0",
		},
	},
});
